module.exports = __webpack_public_path__ + "img/info.ec24a89b.svg";